<script setup>
import { defineProps, ref, defineExpose, nextTick, onMounted} from "vue";
import { useDispatchGAEvent } from '@/hooks/common/useDispatchGAEvent';
import { toggleZIndexToNormal } from "@/hooks/common/useZIndex";
import CountryNav from './WhereToBuyNav.vue';
import useHomeProperties from "@/hooks/common/useHomeProperties";

const props = defineProps({
	product: {
		type: Object,
		default: () => {
			return {};
		}
	},
	config: {
		type: Object,
		default: () => {
			return {};
		},
	}
});
const multiGroup = ref(false);

const visible = ref(false);
const activeAreaId = ref(0);
const currentRetailerList = ref([]);
const parameterRef = ref(null)
const parameterWrap = ref(null)
// currentRetailerList.value = props.config?.retailerGroup?.[0]?.retailerList || props.config?.retailerList || [];
const viewlessmore = ref(false) 
const morelessText = ref(null)
const textelement = ref('')
const viewMoreLessBox = ref(null)
const { viewMoreText , viewLessText } = useHomeProperties(); 

const open = () => {
	toggleZIndexToNormal();
	visible.value = true;
	getparameterRef();
};

const cancel = () => {
	console.log('关闭')
	toggleZIndexToNormal(false);
	visible.value = false;
	if (morelessText.value?.viewMoreText) {
		textelement.value = morelessText.value.viewMoreText
	}
	// 移除class
	parameterWrap.value?.classList.remove('view-more-less-wrap')
	viewMoreLessBox.value?.classList.remove('view-more-less-transform')
};

const handleClickArea = (item, index) => {
	console.log('===click', item, index)
	activeAreaId.value = index;
	currentRetailerList.value = item?.retailerList;
}

const handleRetailerClick = retailer => {
	const { productModelNumber, productName } = props.product;
	const Destination = retailer.buttonLink;

	useDispatchGAEvent('__GA_CLICK_BUY_ON_LINE_CLICK__', {
		items: [{
			item_id: productModelNumber,
			item_name: productName
		}],
		place_name: Destination,
		element: 'Buy Now',
		version: 'old'
	});
};

const getparameterRef = () =>{
	nextTick(() => {
		if (parameterWrap.value && parameterRef.value) {
			textelement.value = morelessText.value.viewMoreText
			// 获取元素高度（offsetHeight包含padding，clientHeight不含border，根据需求选择）
			const wrapHeight = parameterWrap.value.offsetHeight;
			const refHeight = parameterRef.value.offsetHeight;
			
			console.log('容器高度:', wrapHeight, '内容高度:', refHeight);
			
			// 判断并执行逻辑
			if (refHeight > wrapHeight) {
				viewlessmore.value = true
				
			} else {
				viewlessmore.value = false
			}
			console.log('viewlessmore',viewlessmore,props.product,morelessText.value)
		}
	});

}

const changeHideShow = () =>{
	if(textelement.value === morelessText.value.viewMoreText){
		textelement.value = morelessText.value.viewLessText
		// 添加class
		parameterWrap.value.classList.add('view-more-less-wrap')
		viewMoreLessBox.value.classList.add('view-more-less-transform')
	}else {
		textelement.value = morelessText.value.viewMoreText
		// 移除class
		parameterWrap.value.classList.remove('view-more-less-wrap')
		viewMoreLessBox.value.classList.remove('view-more-less-transform')
	}
	
}
const handleRetailerGroup = () => {
	console.log('retailerGroup.value 新的 ',props?.config,multiGroup.value )
	if (multiGroup.value) {
		currentRetailerList.value = props?.config?.retailerGroup?.[0]?.retailerList;
	} else {
		currentRetailerList.value = props?.config?.retailerList;
		// currentRetailerList.value.push(props?.config);
	}
}
onMounted(()=>{
	multiGroup.value = props?.config?.multiGroup === '1'; // 1->多组，0->单组
	handleRetailerGroup();
	console.log('viewMoreTextviewLessText' , viewMoreText,viewLessText)
	if (viewLessText && viewMoreText) {
		morelessText.value = { 
			"viewLessText": viewLessText,
			"viewMoreText":viewMoreText
		}
	}
})

// find nearby按钮逻辑
/* eslint-disable-next-line vue/no-setup-props-destructure */
const showFindNearBy = (() => {
  return props?.config?.enableStore && props?.config?.storeLink && props?.config?.storeLink.trim() !== '#' && props?.config?.findNearbyButtonText;
})();

defineExpose({
	open,
});
</script>

<template>
	<MdDialog
		:title="config.whereToBuyText"
		:visible="visible"
		@close="cancel"
		class="csr-wtb-dialog csr-md-dialog-v2"
		append-to-body
	>
		<div class="csr-wtb-dialog__product">
			<div class="csr-wtb-dialog__product__img" v-if="product?.firstImage">
				<img
					src=""
					:data-src="product?.firstImage"
					class=" lazyload"
					:alt="product.firstImageAltText"
				/>
			</div>
			<div class="csr-wtb-dialog__product__info mdws-product-basic-v2__info">
				<div class="csr-wtb-dialog__product__name" :class="!showFindNearBy?'product-width-auto':''">{{ product.productName }}</div>
				<div class="product-parameter-wrap" :class="!showFindNearBy?'product-width-auto':''" ref="parameterWrap" v-if="product?.productDescription">
					<ul class="product-parameter a" ref="parameterRef">
                        <template 
                            v-for="(decitem, desi) in product.productDescription"
                        >
                            <li
                               :key="desi"
                            >
                            <!-- <span class="product-parameter-title" v-if="decitem?.title">{{ decitem?.title }} <br /></span> -->
                            {{ decitem?.description }}
                            </li>

						
                        </template>
						
					</ul>
				</div>
				<div v-if="viewlessmore" class="view-more-less" ref="viewMoreLessBox" @click="changeHideShow">
					{{ textelement }}
				</div>
				<div class="csr-wtb-dialog__btns__mb">
					<a v-if="showFindNearBy" class="md-button md-button-v2 md-button--default csr-wtb-dialog__find_nearby" :href="config.storeLink" :target="config.storeLinkTarget">{{ config.findNearbyButtonText }}</a>
				</div>
			</div>
			<div v-if="showFindNearBy" class="csr-wtb-dialog__btnsbox">
				<div class="csr-wtb-dialog__btns">
					<a  class="md-button md-button-v2 md-button--default csr-wtb-dialog__find_nearby" :href="config.storeLink" :target="config.storeLinkTarget">{{ config.findNearbyButtonText }}</a>
				</div>
			</div>
		</div>
		<Nav></Nav>
		<div class="csr-wtb-dialog__retailers">
			<div class="csr-wtb-dialog__retailers__title">
				{{ config.buyOnlineText }}
			</div>
			<CountryNav 
				v-if="multiGroup && config.retailerGroup.length" 
				:config="config"
				@itemClick="handleClickArea"
			/>
			<div class="csr-wtb-dialog__retailers__list">
				<div
					v-for="(retailer, ri) in currentRetailerList"
					:key="ri"
					class="csr-wtb-dialog__retailers__item">
					<div class="csr-wtb-dialog__retailers__item__logo">
						<img
							:src="retailer.icon"
							:data-src="retailer.icon"
							class="csr-wtb-dialog__retailers__item__img lazyload"
							:alt="retailer.altText"
						/>
					</div>
					<a
						:href="retailer.buttonLink"
						:target="retailer.target"
						rel="noopener noreferrer"
						class="md-button md-button--txt"
						@click="handleRetailerClick(retailer)"
						:class="retailer.buttonColor === 'black'?'md-button--txt-suffix-icon':'md-button-red--txt-suffix-icon'"
					>{{ retailer.buttonName }}</a>
				</div>
			</div>
		</div>
	</MdDialog>
</template>
